var ViewableSelectorComponent = new JS.Class(EditorComponent, {
  initialize: function(selector) {
    this.$selector = $(selector);
    if (this.$selector.length && this.$selector.is('select')) {
      this.$selector.select2({
        width: 'resolve',
      });
    }
  },

  getSaveData: function() {
    var $blogNonCoursePermissions = $(
      'input[name=blog-non-course-permissions]:checked'
    );
    var $blogCoursePermissions = $(
      'input[name=blog-course-permissions]:checked'
    );

    var courseAssociation = this.$selector.val();
    var viewableBy =
      courseAssociation == ''
        ? $blogNonCoursePermissions.val()
        : $blogCoursePermissions.val();
    var cohort = courseAssociation;

    var policy = 'custom';
    var rules = [];
    switch (viewableBy) {
      case 'private':
        policy = 'private';
        break;
      case 'everyone':
        policy = 'world-read';
        break;
      case 'course':
        rules.push({ type: 'cohort', cohort: cohort, access: 'read' });
    }

    var data = {
      AccessControl: {
        policy: policy,
        rules: rules,
      },
      cohort: cohort,
    };
    return data;
  },
});
